<template>
  <div class="shopIndexPage">    
    <mu-appbar class="XR-head" :title="titleText">
      <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
      <mu-icon-button v-on:click="openShareSheet()" icon=":fa fa-zhuanfa" slot="right" v-if="isApp"/>     
      <mu-icon-menu icon=":fa fa-detail" slot="right">
        <mu-menu-item to="/usercenter/index" title="个人中心"/>
        <mu-menu-item to="/" title="首页"/>
        <mu-menu-item to="/retail/cart" title="购物车"/>
      </mu-icon-menu>
    </mu-appbar> 
    <div class="shopBanner zoomImg" data="">
        <div class="logoBanner">
            <img :src="IndexTemplete.LogoBgImg" class="shopbanner zoomImg" data="9316">
            <img :src="IndexTemplete.ShopLogo?IndexTemplete.ShopLogo:siteInfo.Logo" class="logo zoomImg" data="9204">
        </div>
        <div class="nav">
            <div class="nav-item border"><router-link :to="'/shop/shopIndex?shopId='+IndexTemplete.ShopId">店铺首页</router-link></div>
            <div class="nav-item border" @click="goBrand()">品牌介绍</div>
            <div class="nav-item" @click="goAnchor('#shoppro-list')">全部产品</div>
            
        </div>
        <div>
          <a href="" target="_blank">
            <img :src="IndexTemplete.BannerImg" class="banner zoomImg" data="9321" >
          </a>
        </div>
       
    </div>
    <div class="tuijian" :style="{ height:prolistHeight+'px'}">
        <div class="xuanquan" :style="{width: proAreaLeftWidth+'px'}">
            <div class="info">
                <div class="big" :style="'background:'+IndexTemplete.SloganBg">{{IndexTemplete.Slogan}}</div>
                <div class="normal">{{IndexTemplete.Summary}}</div>
                <div class="img" ref="infoimg">
                    <img :src="IndexTemplete.SloganImg" class="zoomImg" :style="{width:proLeftWidth+'px', height:proLeftHeight+'px'}">
                </div>
            </div>
        </div>
        <div class="pro-list" :style="{width: proAreaRightWidth+'px'}">
          <div style="overflow:hidden; padding-bottom:10px;">
            <div class="pro-item item1" :style="{width:pro1Width+'px'}">
                <div class="img">                
                    <div class="pro-bg" ref="bg1" :style="{height:probg1height+'px',borderColor: IndexTemplete.Pro1Border}"></div>
                    <template v-if="IndexTemplete.Pro1SkuId>0">
                      <router-link :to="'/retail/productDetail?skuId='+IndexTemplete.Pro1SkuId"><img :src="IndexTemplete.Pro1Img" class="pro-img zoomImg" data="9323"></router-link>
                    </template>
                    <template v-else>
                      <a :href="IndexTemplete.Pro1Url"><img :src="IndexTemplete.Pro1Img?IndexTemplete.Pro1Img:IMGServer_URL+'/images/index-item-default.png'" class="pro-img zoomImg" data="9323"></a>
                    </template>
                </div>
                <p class="pro-name">
                    <template v-if="IndexTemplete.Pro1SkuId>0">
                      <img src="/static/icon/icon1.png" class="icon">
                      <span>{{IndexTemplete.Pro1Name}}</span>
                    </template>
                    <template v-if-else>
                      
                    </template>
                </p>
                <p class="pro-price">
                    <span class="sale-price">{{IndexTemplete.Pro1SkuId>0? '￥'+IndexTemplete.Pro1SalePrice : ' '}}</span>
                    <span class="mark-price">{{IndexTemplete.Pro1SkuId>0? '￥'+IndexTemplete.Pro1Price :' '}}</span>
                </p>
            </div>
            <div class="pro-item item2"  :style="{width:pro2Width+'px'}">
                <div class="img" ref="img2" :style="{height:pro2Height+'px'}">       
                    <div class="pro-bg" :style="{width:probg2Width+'px',height:probg2Height+'px',background: IndexTemplete.Pro2Border}"></div>
                    <template v-if="IndexTemplete.Pro2SkuId>0">
                      <router-link :to="'/retail/productDetail?skuId='+IndexTemplete.Pro2SkuId">
                        <img :src="IndexTemplete.Pro2Img?IndexTemplete.Pro2Img:IMGServer_URL+'/images/index-item-default.png'" class="pro-img zoomImg" data="9317" :style="{width:proimg2Width+'px',height:proimg2Height+'px'}">
                      </router-link>
                    </template>
                    <template v-else>
                      <a :href="IndexTemplete.Pro2Url">
                        <img :src="IndexTemplete.Pro2Img?IndexTemplete.Pro2Img:IMGServer_URL+'/images/index-item-default.png'" class="pro-img zoomImg" data="9317" :style="{width:proimg2Width+'px',height:proimg2Height+'px'}">
                      </a>
                    </template>
                </div>
                <p class="pro-name">
                  <template v-if="IndexTemplete.Pro2SkuId>0">
                    <img src="/static/icon/icon1.png" class="icon">
                    <span>{{IndexTemplete.Pro2Name}}</span>
                  </template>
                  <template v-if-else>
                    
                  </template>
                </p>
                <p class="pro-price">
                    <span class="sale-price">{{IndexTemplete.Pro2SkuId>0? '￥'+IndexTemplete.Pro2SalePrice : ' '}}</span>
                    <span class="mark-price">{{IndexTemplete.Pro2SkuId>0? '￥'+IndexTemplete.Pro2Price :' '}}</span>
                </p>
            </div>
          </div>
          <div style="overflow:hidden;">
            <div class="pro-item item3" :style="{width:pro3Width+'px',height:pro3Height+'px'}">                
                <div class="shopAdFont">
                    <p class="font1">{{IndexTemplete.Title}}</p>
                </div>
                <div class="img" :style="{height: proimg3Height+'px'}">
                    <div class="pro-bg" :style="{width:probg3Width+'px',height:probg3Height+'px',marginTop:pro3Top+'px',borderColor: IndexTemplete.Pro3Border}"></div>
                    <template v-if="IndexTemplete.Pro3SkuId>0">
                      <router-link :to="'/retail/productDetail?skuId='+IndexTemplete.Pro3SkuId">
                        <img :src="IndexTemplete.Pro3Img?IndexTemplete.Pro3Img:IMGServer_URL+'/images/index-item-default.png'" :style="{height:item3imgHeight+'px'}" class="pro-img zoomImg" data="9319"  >
                      </router-link>
                    </template>
                    <template v-else>
                      <a :href="IndexTemplete.Pro3Url">
                        <img :src="IndexTemplete.Pro3Img?IndexTemplete.Pro3Img:IMGServer_URL+'/images/index-item-default.png'" :style="{height:item3imgHeight+'px'}" class="pro-img zoomImg" data="9319"  >
                      </a>
                    </template>
                </div>
                <p class="pro-name">
                    <template v-if="IndexTemplete.Pro3SkuId>0">
                    <img src="/static/icon/icon1.png" class="icon">
                    <span>{{IndexTemplete.Pro3Name}}</span>
                  </template>
                  <template v-if-else>
                  </template>
                </p>
                <p class="pro-price">
                    <span class="sale-price">{{IndexTemplete.Pro3SkuId>0? '￥'+IndexTemplete.Pro3SalePrice : ' '}}</span>
                    <span class="mark-price">{{IndexTemplete.Pro3SkuId>0? '￥'+IndexTemplete.Pro3Price :' '}}</span>
                </p>
            </div>
            <div class="pro-item item4">
                <template v-if="IndexTemplete.Pro4SkuId>0">
                  <router-link :to="'/retail/productDetail?skuId='+IndexTemplete.Pro4SkuId">
                    <img :src="IndexTemplete.Pro4Img?IndexTemplete.Pro4Img:IMGServer_URL+'/images/index-item-default.png'" class="pro-img zoomImg" :style="{height: proimg4Height+'px'}">
                  </router-link>
                </template>
                <template v-else>
                  <a :href="IndexTemplete.Pro4Url">
                    <img :src="IndexTemplete.Pro4Img?IndexTemplete.Pro4Img:IMGServer_URL+'/images/index-item-default.png'" class="pro-img zoomImg" :style="{height: proimg4Height+'px'}">
                  </a>
                </template>
                <p class="pro-name">
                  <template v-if="IndexTemplete.Pro4SkuId>0">
                    <img src="/static/icon/icon1.png" class="icon">
                    <span>{{IndexTemplete.Pro4Name}}</span>
                  </template>
                  <template v-if-else>
                  </template>
                </p>
                <p class="pro-price">
                    <span class="sale-price">{{IndexTemplete.Pro4SkuId>0? '￥'+IndexTemplete.Pro4SalePrice : ' '}}</span>
                    <span class="mark-price">{{IndexTemplete.Pro4SkuId>0? '￥'+IndexTemplete.Pro4Price :' '}}</span>
                </p>
            </div>
          </div>
        </div>
      </div>
      <div class="brandStory">
        <img :src="IndexTemplete.BrandImg" alt="">
        <div class="story">
            <h2>Brand Story</h2>
            <h2>品牌故事</h2>
            <p>{{IndexTemplete.BrandStory}}</p> 
        </div>
      </div>
      <div class="shop_coupon" v-if="!closeCoupon">
          <div class="couponTitle" v-if="shopCouponInfo.TopCoupon && shopCouponInfo.TopCoupon.Id>0">
              <div class="wow">
                <img src=" ../static/coupon/3.png" alt="">
              </div>
              <div class="row" :style="{width:couponWidth+'px'}">
                <div class="count">
                  ￥<span class="countNum">{{shopCouponInfo.TopCoupon.Money}}</span>
                </div>       
                <div class="prouductName">
                  <p>{{shopCouponInfo.TopCoupon.Name}}</p> 
                </div>
              </div>
              <mu-raised-button label="即领即用" class="demo-raised-button" secondary @click="receiveCoupon(shopCouponInfo.TopCoupon.Id)" />
          </div>
          <div class="couponType" v-if="shopCouponInfo.CouponItem && shopCouponInfo.CouponItem.length>0">
              <div class="couponPrice">
                  <div class="couponOne" v-for="couponItem in shopCouponInfo.CouponItem" :key="couponItem.Id" @click="receiveCoupon(couponItem.Id)">
                      <p class="price">￥<span>{{couponItem.Money}}</span></p>
                      <p>满{{couponItem.FullMoney}}可用</p>
                  </div>
              </div>
              <p class="date"></p>
          </div>
      </div>
      <div class="pintuan" v-if="gshopShow">
        <p class="groupNum">{{pinTuanInfo.FshareTitle}}</p>
        <p class="groupName">{{pinTuanInfo.Fname}}</p>
        <mu-list-item class="product">
          <div class="product_item" >                   
                <img :src="pinTuanInfo.ImagePath" class="proImg" alt=""> 
                <div class="product_info" :style="{width: proItemInfoWidth +'px'}">
                    <div class="product_title">
                        <span class="slaePrice">{{pinTuanInfo.ZheKou}}折</span>
                        <span class="prime_cost">指导价{{pinTuanInfo.OldPrice}}元</span>
                        {{pinTuanInfo.ProductName}}
                    </div>
                    <div class="sign">
                      <div class="shopNum sign">3人团</div>
                      <div class="free_post sign">包邮</div>
                    </div> 
                    <div class="price_time">
                        <p class="price">拼团价<span>{{pinTuanInfo.FminSkuPrice}}</span>元</p>
                        <p class="countdown">距离结束<span class="time">{{pinTuanInfo.FremainingTime}}</span></p>
                    </div>
                    <router-link :to="'/retail/productDetail?skuId=' +pinTuanInfo.FminSkuId + '&activityId=' +pinTuanInfo.Fid " >
                      <div class="num_goshop">         
                        <p class="sellCount">已团{{pinTuanInfo.FgroupNumber}}件</p>
                          <mu-raised-button label="去拼团" class="demo-raised-button"/>                                 
                      </div>
                    </router-link>  
                </div>                     
              
            </div>
          </mu-list-item>
      </div>
    <div class="sort">
          <mu-tabs :value="activeTab" @change="handleTabChange">
            <mu-tab value="isStock" @click="sortClick()"><span>有货 </span><i :class="'fa fa-angle-' + (this.activeTab =='isStock' && this.searchInfo.orderBy?'down':'up')"></i></mu-tab>
            <mu-tab value="price" @click="sortClick()"><span>价格 </span><i :class="'fa fa-angle-' + (this.activeTab =='price' && this.searchInfo.orderBy?'down':'up')"></i></mu-tab>
            <mu-tab value="isNew" @click="sortClick()"><span>新品 </span><i :class="'fa fa-angle-' + (this.activeTab =='isNew' && this.searchInfo.orderBy?'down':'up')"></i></mu-tab>
            <mu-tab value="count" @click="sortClick()"><span>销量 </span><i :class="'fa fa-angle-'+ (this.activeTab =='count' && this.searchInfo.orderBy?'down':'up')"></i></mu-tab>
            <mu-tab value="all" @click="sortClick()"><span>全部 </span><i :class="'fa fa-angle-' + (this.activeTab =='all' && this.searchInfo.orderBy?'down':'up')"></i></mu-tab>
        </mu-tabs>
    </div>
    <div class="shoppro-list" id="shoppro-list">
      <div :class="'item '+ (index%2==0?'rigthmargin':'') " v-for="(pItem,index) in productList" :key="index">
        <div class="top">
          <router-link :to="'/retail/productDetail?skuId='+pItem.SkuId">
          <img :src="(pItem.Images && pItem.Images.length>0 ? pItem.Images[0].ImgPath : IMGServer_URL+'/images/index-item-default.png')" class="pro-img">
          </router-link>
        </div>
        <div class="text">
          <div class="money">
            <p class="price">￥<span>{{pItem.SalePriceName}}</span></p>
            <p class="del-price">￥{{pItem.PriceName}}</p>
          </div>
          <p class="name">{{pItem.Name}}</p>
        </div>
      </div>
      <div v-if="isShowLastDefault" class="item">
          <img style="width: 100%;display: block;" src="/static/index/index-item-default.png"  />
      </div>  
    </div>
    
    <mu-bottom-sheet :open="shareSheet" @close="closeShareSheet">    
      <div class="shopIndexPage-shareSheetTitle">分享到</div>
      <div class="shopIndexPage-shareSheetWayList">
        <div class="shareSheetWayItem" @click="appWeChatFringtShareClick">
          <div class="shareWayIcon wechatFrind"><i class="fa fa-wechat"></i></div>
          <div class="shareWayText">微信好友</div>
        </div>
        <div class="shareSheetWayItem" @click="appWeChatFringtQuanShareClick">          
          <div class="shareWayIcon wechatFrindQuan"><i class="fa fa-diamonds"></i></div>
          <div class="shareWayText">朋友圈</div>
        </div>
      </div>   
    </mu-bottom-sheet>

    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import appShare from '../../util/appShare'
import wechatCache from '../../util/wechatCache'
export default {
  data() {
    return {
      titleText:'店铺首页',
      activeTab: "all",
      proItemInfoWidth: (parseInt(document.documentElement.clientWidth)-137),
      couponWidth: document.documentElement.clientWidth * 0.96*0.75-88,
      proAreaWidth: document.documentElement.clientWidth * 0.96,
      IndexTemplete: {},
      searchInfo:{
        shopId: this.$route.query.shopId,
        categoryId:0,
        isStock:false,
        isNew:false,
        orderField:'',
        orderBy:false
      },
      isShowLastDefault:false,
      productList:[],
      siteInfo:[],
      pinTuanInfo:[],
      isBrandIndex: false,    
      shareSheet:false,
      shareTitle:'',
      shareDesc:'',
      shareImgUrl:'',
      shareLinkUrl:'',  
      isApp:false,
      gshopShow:true,

      shopCouponInfo:{},//店铺优惠券信息
    };
  },
  created(){
    window.openShare = this.openShare
  },
  mounted() {    
    var url = window.location.href
    if(/[?]from=(.)*#/.test(url)){
      url = url.replace(/[?]from=(.)*#/g , "#")
      window.location.href = url
      return
    }
    
    var appClient = window.localStorage.appClient
        if(appClient == 'android' || appClient == 'ios'){
        this.isApp = true
    }

    this.getShopIndex()
    this.getProductList()
    this.addShopCount()
    this.getSiteInfo()
    this.getShopBrand()
    this.getPinTuanInfo()
    this.getShopCouponList()
  },
  methods: {
    addShopCount(){      
      var ths = this;
      ths.$post("/Shop/StoreServer/AddShopsAccess",{
            shopId: this.searchInfo.shopId
      })
      .then(function(res) {
        if (res.IsSuccess) {
        }
      });
    },
    handleTabChange(val) {
      this.activeTab = val;
    },    
    GoHistory(){
      this.$router.goBack()
    },
    sortClick(){
      if(this.activeTab == 'isStock'){
        this.searchInfo.orderField = ''
        this.searchInfo.orderBy = !this.searchInfo.orderBy

        this.searchInfo.isStock = true
        this.searchInfo.isNew = false
      }
      else if(this.activeTab == 'price'){
        this.searchInfo.isStock = false
        this.searchInfo.isNew = false

        this.searchInfo.orderField = this.activeTab 
        this.searchInfo.orderBy = !this.searchInfo.orderBy
      }
      else if(this.activeTab == 'isNew'){
        this.searchInfo.orderField = ''
        this.searchInfo.orderBy = !this.searchInfo.orderBy

        this.searchInfo.isStock = false
        this.searchInfo.isNew = true
      }
      else if(this.activeTab == 'count'){
        this.searchInfo.isStock = false
        this.searchInfo.isNew = false

        this.searchInfo.orderField = this.activeTab 
        this.searchInfo.orderBy = !this.searchInfo.orderBy
      }
      else if(this.activeTab == 'all'){
        this.searchInfo.isStock = false
        this.searchInfo.isNew = false

        this.searchInfo.orderField = ''
        this.searchInfo.orderBy = !this.searchInfo.orderBy
      }

      this.getProductList()
    },
    getShopBrand:function(){
      if (this.searchInfo.shopId) {
        var ths = this;
        ths.$post("/Shop/StoreServer/GetShopsBrandStoreTemplate", {
            shopId: this.searchInfo.shopId
          })
          .then(function(res) {
            if (res.IsSuccess) {
              ths.isBrandIndex = true;
            }
          });
      } else {
        this.$refs.XRtoast.failed("未登录", true);
      }
    },
    getShopIndex: function() {
      if (this.searchInfo.shopId) {
        var ths = this;
        ths
          .$post("/Shop/StoreServer/GetShopIndexTemplateInfo", {
            shopId: this.searchInfo.shopId
          })
          .then(function(res) {
            if (res.IsSuccess) {
              ths.favState = false;

              ths.IndexTemplete = res.Data;
              
              if(ths.IndexTemplete.Id<=0){                
                ths.IndexTemplete.LogoBgImg = '/static/store/logoBg.png'
                ths.IndexTemplete.SloganImg = '/static/store/slogan.png'
                ths.IndexTemplete.Pro1Img = '/static/store/ad1.png'
                ths.IndexTemplete.Pro2Img = '/static/store/ad2.png'
                ths.IndexTemplete.Pro3Img = '/static/store/ad3.png'
                ths.IndexTemplete.Pro4Img = '/static/store/ad4.png'
                ths.IndexTemplete.Pro5Img = '/static/store/ad5.png'
                ths.IndexTemplete.LogoBgImg = '/static/store/logoBg.png'
                ths.IndexTemplete.LogoBgImg = '/static/store/logoBg.png'
              }else{
                if(ths.isNumber(ths.IndexTemplete.Pro1Img)){
                  ths.IndexTemplete.Pro1Img = ths.IMGServer_URL + '/api/img/getPath?id=' + ths.IndexTemplete.Pro1Img
                }
                if(ths.isNumber(ths.IndexTemplete.Pro2Img)){
                  ths.IndexTemplete.Pro2Img = ths.IMGServer_URL + '/api/img/getPath?id=' + ths.IndexTemplete.Pro2Img
                }
                if(ths.isNumber(ths.IndexTemplete.Pro3Img)){
                  ths.IndexTemplete.Pro3Img = ths.IMGServer_URL + '/api/img/getPath?id=' + ths.IndexTemplete.Pro3Img
                }
                if(ths.isNumber(ths.IndexTemplete.Pro4Img)){
                  ths.IndexTemplete.Pro4Img = ths.IMGServer_URL + '/api/img/getPath?id=' + ths.IndexTemplete.Pro4Img
                }
              }

              ths.initWeiXin()
              
              ths.titleText =res.Data.ShopName
            }
          });
      } else {
        this.$refs.XRtoast.failed("未登录", true);
      }
    },    
    getProductList: function() {
      if (this.searchInfo.shopId) {
        var ths = this;
        ths
          .$post("/Shop/RetailServer/GetShopSaleProductList", this.searchInfo)
          .then(function(res) {
            if (res.IsSuccess) {
              ths.favState = false;
              ths.productList = res.Data.List;
              ths.isShowLastDefault = ths.productList.length % 2==1?true:false
            }
          });
      } else {
        this.$refs.XRtoast.failed("未登录", true);
      }
    }, 
    getPinTuanInfo: function() {      
      var ths = this;
      ths
      .$post("/Shop/PinTuanServer/WapStoreGetIndex",{ uid : this.searchInfo.shopId })
        .then(function(res) {
          if (res.IsSuccess) {
            ths.pinTuanInfo = res.Data;
            if(ths.pinTuanInfo==null){
              ths.gshopShow=false
            }
          }
        })
        .catch(function(err) {
          console.log(err);
           ths.gshopShow=false
        });
        
    },
    isNumber(num){
      var re = /^[1-9]+[0-9]*]*$/;
      if (!re.test(num)){
        return false;
      }
      return true;
    },    
    getSiteInfo: function() {
      const ths = this;
      this.$post("/Shop/SiteConfigServer/GetSiteConfig")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          ths.siteInfo = res.Data;
          ths.$refs.XRtoast.hide();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    goBrand(){
      if(!this.isBrandIndex){
        this.$refs.XRtoast.failed("暂无信息", true)
        return
      }
      this.$router.push('/brandStore/index?shopId='+ this.searchInfo.shopId)
    },    
    goAnchor(val) {
      let anchor = this.$el.querySelector(val);
        this.$nextTick(() => {
          document.querySelector(".shopIndexPage").scrollTop = anchor.offsetTop;
        });
    },
    
    initWeiXin(){
      var ths = this;   

      ths.shareTitle = ths.IndexTemplete.ShopName
      ths.shareDesc = "我在"+ths.siteInfo.SiteName+"发现一家不错的店，赶快来看看吧"
      ths.shareImgUrl = ths.IndexTemplete.ShopLogo
      if(!ths.shareImgUrl){
        ths.shareImgUrl = ths.siteInfo.Logo
      }
      ths.shareLinkUrl = window.location.href 
      if(ths.isBrandIndex){
        ths.shareLinkUrl = ths.MOBILE_URL + '/#/brandStore/index?shopId='+ ths.searchInfo.shopId
      }    
      ths.shareLinkUrl = ths.shareLinkUrl.replace(/[/][?].*#/,"/#"); 
       
      var openId = wechatCache.getOpenId()
      if(!openId){
        //this.$refs.XRtoast.failed('未获取微信信息', true)
        return
      }   
      ths.$postBase(
      ths.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{   
          
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              wx.onMenuShareTimeline({
                  title: ths.shareTitle, // 分享标题
                  link: ths.shareLinkUrl, // 分享链接
                  imgUrl: ths.shareImgUrl, // 分享图标
                  success: function () {
                  },
                  cancel: function () {
                      // 用户取消分享后执行的回调函数
                  }
              });

              wx.onMenuShareQQ({
                  title: ths.shareTitle, // 分享标题
                  desc: ths.shareDesc, // 分享描述
                  link: ths.shareLinkUrl, // 分享链接
                  imgUrl: ths.shareImgUrl, // 分享图标
                  success: function () {
                  },
                  cancel: function () {
                      // 用户取消分享后执行的回调函数
                  }
              });

              wx.onMenuShareAppMessage({
                  title: ths.shareTitle, // 分享标题
                  desc: ths.shareDesc, // 分享描述
                  link: ths.shareLinkUrl, // 分享链接
                  imgUrl: ths.shareImgUrl, // 分享图标
                  success: function () {
                  },
                  cancel: function () {
                      // 用户取消分享后执行的回调函数
                  }
              });
              wx.onMenuShareQZone({
                  title: ths.shareTitle, // 分享标题
                  desc: ths.shareDesc, // 分享描述
                  link: ths.shareLinkUrl, // 分享链接
                  imgUrl: ths.shareImgUrl, // 分享图标
                  success: function () {
                      // 用户确认分享后执行的回调函数
                  },
                  cancel: function () {
                      // 用户取消分享后执行的回调函数
                  }
              });
          });
      }
      }); 
    },    
    closeShareSheet () {
      this.shareSheet = false
    },
    openShareSheet () {
      var appClient = window.localStorage.appClient
      if(appClient == 'ios'){      
        window.webkit.messageHandlers.ajax.postMessage({fun:'share',Ftitle: this.shareTitle,Fimage:this.shareImgUrl ,FjumpUrl: this.shareLinkUrl})
      }else{
        this.shareSheet = true
      }
    },         
    openShare(){
        this.shareSheet = true
    },
    appWeChatFringtShareClick(){
      appShare.shareWeChatFriend(this.shareTitle,this.shareDesc,this.shareImgUrl,this.shareLinkUrl)
    },    
    appWeChatFringtQuanShareClick(){
      appShare.shareWeChatFriendQuan(this.shareTitle,this.shareDesc,this.shareImgUrl,this.shareLinkUrl)
    },
    getShopCouponList:function(){
      if (this.searchInfo.shopId) {
        var ths = this;
        ths.$post("/Shop/CouponServer/WapShopsCoupon", {
            shopId: this.searchInfo.shopId
          })
          .then(function(res) {
            if (res.IsSuccess) {
              ths.shopCouponInfo = res.Data;
            }
          });
      } else {
        //this.$refs.XRtoast.failed("未登录", true);
      }
    },
    
    receiveCoupon(num){
      if (!this.$store.state.user.SessionId) {
        this.loginUrl = "/Login";
		this.$router.push(this.loginUrl+"?redirect="+encodeURIComponent(this.$router.history.current.fullPath)+"&msg="+encodeURIComponent("请先登录再领券"));
        return;
      }else{
        var ths = this;
        ths.$post('/Shop/CouponServer/WapReceiveCoupon',{'CouponId':num}
        ).then(function (res) {
          if(!res.IsSuccess){
            ths.$refs.XRtoast.failed(res.Msg, true)
          }else{
            ths.getShopCouponList()
          }
        })
      }
    },
  },
  computed: {
    proAreaLeftWidth: function() {
      return this.proAreaWidth * 0.37;
    },
    proLeftWidth: function() {
      return this.proAreaLeftWidth * 0.759;
    },
    proLeftHeight: function() {
      return this.proLeftWidth / 0.5;
    },
    proAreaRightWidth: function() {
      return this.proAreaWidth * 0.66;
    },
    pro1Width: function() {
      return this.proAreaRightWidth * 0.387;
    },
    probg1height: function() {
      return this.pro1Width * 1;
    },
    pro2Width: function() {
      return this.proAreaRightWidth * 0.413;
    },
    pro2Height: function() {
      return this.pro2Width / 0.86;
    },
    probg2Width: function() {
      return this.pro2Width * 0.9;
    },
    probg2Height: function() {
      return this.pro2Width * 0.2;
    },
    proimg2Width: function() {
      return this.pro2Width * 0.95;
    },
    proimg2Height: function() {
      return this.pro2Width / 0.92;
    },
    pro3Width: function() {
      return this.proAreaRightWidth * 0.51;
    },
    item3imgHeight:function(){
      return this.proAreaRightWidth * 0.51*0.78
    },
    pro3Height: function() {
      return this.pro3Width / 0.81;
    },
    probg3Width: function() {
      return this.pro3Width * 0.96;
    },
    probg3Height: function() {
      return this.probg3Width / 1.6;
    },
    proimg3Width: function() {
      return this.pro3Width * 0.78;
    },
    prog3Height: function() {
      return this.proimg3Width * 0.78;
    },
    proimg3Height: function() {
      return this.proimg3Width;
    },
    proitem4Width:function(){
      return this.proAreaRightWidth*0.387
    },
    proimg4Height:function(){
      return this.proitem4Width/0.7
    },
    Top: function() {
      return this.proimg3Width - this.probg3Height;
    },
    pro3Top: function() {
      return this.Top / 2;
    },
    prolistHeight: function() {
      return this.pro2Height + this.pro3Height + 85;
    },

  }
};
</script>

<style>
body .shopIndexPage{
  background: white;
}
.shopIndexPage .head{
  position: fixed;
}
.shopIndexPage .shopInfo {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  height: 45px;
}
.shopIndexPage .shopInfo .shopName {
  font-size: 14px;
  float: left;
  line-height: 45px;
}
.shopIndexPage .shopInfo .line {
  float: left;
  line-height: 45px;
  width: 20px;
  text-align: center;
}
.shopIndexPage .shopInfo .shopPj {
  float: left;
  line-height: 45px;
}

.shopIndexPage .shopBanner {
  overflow: hidden;
  background: red;
}
.shopIndexPage .shopBanner .logoBanner {
  width: 100%;
  margin: 0 auto;
  height: 55px;
  overflow: hidden;
  position: relative;
  background: #c4c7cc;
}
.shopIndexPage .shopBanner .logoBanner .shopbanner {
  display: block;
  height: 55px;
  width:100%;
}
.shopIndexPage .shopBanner .logoBanner .logo {
  display: block;
  position: absolute;
  top: 0;
  left: 20px;
  width: 55px;
}

.shopIndexPage .shopBanner .nav {
  overflow: hidden;
  height: 48px;
  background: #231815;
  padding: 10px 0;
}
.shopIndexPage .shopBanner .nav .nav-item {
  float: left;
  width: 33%;
  line-height: 28px;
  text-align: center;
  color: White;
  position: relative;
}
.shopIndexPage .shopBanner .nav .nav-item.border:after {
  content: "";
  background: white;
  width: 1px;
  height: 20px;
  position: absolute;
  top: 4px;
  right: 0;
}

.shopIndexPage .shopBanner .banner {
  width: 100%;
  display: block;
  margin: 0 auto;
}

.shopIndexPage .tuijian {
  background: white;
  margin: 30px 2% 20px;
  position: relative;
}
.shopIndexPage .brandStory{
  width: 100%;
  margin-bottom: 20px;
  position: relative;
  color: #fff;
  background: #000;
}
.shopIndexPage .brandStory h2{
  font-size: 1rem;
}
.shopIndexPage .brandStory img{
  width: 100%;
  height: 155px;
  display: block;
}
.shopIndexPage .brandStory .story{
  background: rgba(100,100,100, 0.3);
  width: 60%;
  height: 80%;
  position: absolute;
  right: 2%;
  top: 10%;
  padding: 5px 10px;
}
.shopIndexPage .brandStory .story p{ 
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.shopIndexPage .shop_coupon{
  width: 100%;
  padding: 0 2%;
  margin-bottom: 20px;
  
}
.shopIndexPage .shop_coupon .couponTitle{
  width: 100%;
  display: flex;
  justify-content: center;
  background-image: url(' ../../../static/coupon/store_bg1.png');
  background-size: 100% 100%;
  align-items: center;
}
.shopIndexPage .shop_coupon .wow{
  width: 25%;
}
.shopIndexPage .shop_coupon img{
  width: 100%;
}
.shopIndexPage .shop_coupon .couponTitle .row{
  display: flex;
  justify-content: center;
  
}
.shopIndexPage .shop_coupon .couponTitle .row .count{
  color: #E9357C;
  padding-top: 5px;
}
.shopIndexPage .shop_coupon .couponTitle .row .count span.countNum{
  font-size: 30px;
}
.shopIndexPage .shop_coupon .couponTitle .row .prouductName{
  margin-top: 10px;
  margin-left: 5px;
}
.shopIndexPage .shop_coupon .couponTitle .row .prouductName p{
  font-size: 12px;
  line-height: 15px;
  color: #83571D;
}
.shopIndexPage .shop_coupon .couponTitle .mu-raised-button{
 background: #E7168D;
 height: 22px;
 line-height: 22px;
 border-radius: 14px;
 min-width: 80px;
 width: 80px;
}
.shopIndexPage .shop_coupon .couponTitle .mu-raised-button .mu-raised-button-label{
 font-size: 12px;
}
.shopIndexPage .couponType{
  width: 100%;
  padding: 0 2%;
  background-image: url(' ../../../static/coupon/store_bg2.png');
  background-size: 100% 100%;
}
.shopIndexPage .couponType .couponPrice{
  display: flex;
  justify-content: center;
  padding-top: 10px;
}
.shopIndexPage .couponType .couponPrice .couponOne{
  width: 33.3%;
  text-align: center;
  color: #fff;
  
}
.shopIndexPage .couponType .couponPrice .couponOne .price{
  height: 35px;
  line-height: 35px;
}
.shopIndexPage .couponType .couponPrice .couponOne p span{
  font-size: 30px;
}
.shopIndexPage .couponType .couponPrice .couponOne:not(:first-child){
  border-left: 1px dashed #fff;
}
.shopIndexPage .couponType .date{
  text-align: center;
  color: #8B3428;
  font-size: 12px;
  padding: 4px 0;
}
.shopIndexPage .pintuan{
  background-image: url( ../../../static/shopPintuan.png);
  background-size: 100%  100%;
  height: 230px;
}
.shopIndexPage .pintuan .groupNum{
  margin-top: 10px;
  text-align: center;
  font-size: 16px;
  line-height: 30px;
}
.shopIndexPage .pintuan .groupName{
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.shopIndexPage .pintuan .product .product_item .product_info{
  float: right;
  margin-left: 10px;
}
.shopIndexPage .pintuan .product .product_item .product_info .product_title{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 14px;
  color: #000;
}
.shopIndexPage .pintuan .product .product_item .product_info .product_title .slaePrice{
  color: red;
  font-weight: bold;
}
.shopIndexPage .pintuan .product .product_item .product_info .product_title .prime_cost{
  color: #666;
}
.shopIndexPage .pintuan .product .product_item .product_info .sign{
  text-align: center;
  border-radius: 2px;
  color: #fff;
  font-size: 12px;
  padding: 1px 0;
  overflow: hidden;
}
.shopIndexPage .pintuan .product .product_item .product_info .sign .shopNum{
  background: #EB4D54;
  width: 40px;
  border-radius: 5px;
  margin-right: 10px;
  float: left;
}
.shopIndexPage .pintuan .product .product_item .product_info .sign .free_post{
  float: left;
  width: 30px;
  border-radius: 5px;
  margin-right: 10px;
  background: #CC9137;
}
.shopIndexPage .pintuan .product .product_item .product_info .price_time{
  float: left;
}
.shopIndexPage .pintuan .product .product_item .product_info .num_goshop{
  float: right;
  margin-top: 10px;
}
.shopIndexPage .pintuan .product .product_item .product_info .price_time .price{
  color: #C13B38;
  font-size: 14px;
  line-height: 20px;
  height: 20px;
  margin-top: 10px;
}
.shopIndexPage .pintuan .product .product_item .product_info .price_time .countdown{
  font-size: 12px;
  color: #666;
}
.shopIndexPage .pintuan .product .product_item .product_info .price_time .countdown span.time{
  padding-left: 5px;
  color: #DF8384;
  line-height: 25px;
}
.shopIndexPage .pintuan .product .product_item .product_info .price_time .price span{
  font-size: 20px;
  padding: 0 5px;
}
.shopIndexPage .pintuan .product .product_item .product_info .num_goshop .sellCount{
  font-size: 12px;
  color: #999;
  text-align: left;
}
.shopIndexPage .pintuan .product .product_item .product_info .num_goshop .mu-raised-button{
  min-width: 60px;
  height: 25px;
  background: #C13B38;
  color: #fff;
}
.shopIndexPage .pintuan .product .product_item .proImg{
  width: 95px;
  float: left;
  background: white;
  height: 95px;
}
.shopIndexPage .tuijian .xuanquan {
  width: 37%;
}

.shopIndexPage .tuijian .xuanquan .info .big {
  text-align: center;
  height: 23px;
  line-height: 23px;
  overflow: hidden;
  color: white;
}
.shopIndexPage .tuijian .xuanquan .info .normal {
  height: 42px;
  overflow: hidden;
  font-size: 12px;
  line-height: 14px;
  margin: 16px 8px 20px;
}
.shopIndexPage .tuijian .xuanquan .info .img {
  width: 75.9%;
  padding: 0 8px;
}
.shopIndexPage .tuijian .xuanquan .info .img img {
  width: 100%;
}

.shopIndexPage .tuijian .pro-list {
  position: absolute;
  top: 0;
  left: 33.9%;
  width: 66%;
}
.shopIndexPage .tuijian .pro-list .pro-item {
  float: left;
}
.shopIndexPage .tuijian .pro-list .pro-item .pro-price {
  line-height: 12px;
}
.shopIndexPage .tuijian .pro-list .pro-item .pro-price .mark-price {
  display: none;
}
.shopIndexPage .tuijian .pro-list .pro-item .pro-price .sale-price {
  font-size: 12px;
  color: Red;
}
.shopIndexPage .tuijian .pro-list .pro-item .pro-img {
  width: 100%;
}
.shopIndexPage .tuijian .pro-list .pro-item .pro-name {
  position: relative;
  margin-top: 10px;
  line-height: 12px;
}
.shopIndexPage .tuijian .pro-list .pro-item .pro-name img {
  width: 10px;
  float: left;
  margin-top: 4px;
}
.shopIndexPage .tuijian .pro-list .pro-item .pro-name span {
  width: 80%;
  float: left;
  line-height: 18px;
  font-size: 12px;
  height: 18px;
  overflow: hidden;
  vertical-align: middle;
}

.shopIndexPage .tuijian .pro-list .pro-item.item1 {
  margin-left: 9.4%;
  width: 38.7%;
  margin-top: 10px;
}
.shopIndexPage .tuijian .pro-list .pro-item.item1 .img {
  position: relative;
}
.shopIndexPage .tuijian .pro-list .pro-item.item1 .img .pro-bg {
  border: 1px solid black;
}
.shopIndexPage .tuijian .pro-list .pro-item.item1 .img .pro-img {
  position: absolute;
  top: 8px;
  left: 8px;
  height: 100%;
}
.shopIndexPage .tuijian .pro-list .pro-item.item2 {
  margin-left: 10.6%;
  width: 41.3%;
}
.shopIndexPage .tuijian .pro-list .pro-item.item2 .img {
  position: relative;
  height: 100%;
}
.shopIndexPage .tuijian .pro-list .pro-item.item2 .img .pro-bg {
  width: 5%;
  height: 5%;
  position: absolute;
  bottom: 2.5%;
  right: 0;
}
.shopIndexPage .tuijian .pro-list .pro-item.item2 .img .pro-img {
  position: absolute;
  top: 0;
  left: 0;
}
.shopIndexPage .tuijian .pro-list .pro-item.item2 .pro-name img {
  width: 10px;
  float: left;
  margin-top: 4px;
}
.shopIndexPage .tuijian .pro-list .pro-item.item3 {
  width: 51%;
}
.shopIndexPage .tuijian .pro-list .pro-item.item3 .shopAdFont {
}
.shopIndexPage .tuijian .pro-list .pro-item.item3 .shopAdFont .font1 {
  font-size: 14px;
  line-height: 14px;
  height: 28px;
  overflow: hidden;
  text-align: center;
  word-break: break-all;
}
.shopIndexPage .tuijian .pro-list .pro-item.item3 .img {
  position: relative;
  overflow: hidden;
  margin-top: 4px;
      display: flex;
    justify-content: center;
}
.shopIndexPage .tuijian .pro-list .pro-item.item3 .pro-bg {
  width: 96%;
  background: white;
  border: 2px solid red;
}
.shopIndexPage .tuijian .pro-list .pro-item.item3 .pro-img {
  width: 78%;
  position: absolute;
  top: 0;
  left: 11%;
}
.shopIndexPage .tuijian .pro-list .pro-item.item4 {
  width: 38.7%;
  margin-left: 9%;
  margin-top: 10px;
}
.shopIndexPage .tuijian .pro-list .pro-item.item4 .pro-name {
  margin-top: 0;
}

.shopIndexPage .sort {
  width: 100%;
  height: 45px;
  background: #fff;
  margin: 0 auto;
}
.shopIndexPage .sort .sort-item {
  overflow: hidden;
  float: left;
  width: 20%;
  height: 24px;
  padding: 10px 0 11px;
  cursor: pointer;
  text-align: center;
  position: relative;
}
.shopIndexPage .sort .sort-item.border:after {
  content: "";
  background: #c0c1c2;
  width: 1px;
  height: 14px;
  position: absolute;
  right: 0;
  top: 15px;
}
/*.sort .sort-item.item1 { width:15%;}*/
.shopIndexPage .sort .sort-item .sort-box {
  overflow: hidden;
  text-align: center;
}
.shopIndexPage .sort .sort-item .sort-box .text {
  font-size: 14px;
  line-height: 24px;
  text-align: center;
}
.shopIndexPage .sort .sort-item.up .sort-box .text .fa-angle-down {
  display: none;
}
.shopIndexPage .sort .sort-item.down .sort-box .text .fa-angle-up {
  display: none;
}
.shopIndexPage .sort .sort-item.select {
  background: #f3e0c4;
}
.shopIndexPage .sort .sort-item.select .sort-box .text {
  color: #ea8e00;
}
.shopIndexPage .sort .sort-total {
  overflow: hidden;
  float: right;
  padding: 15px 40px 16px 0;
  height: 14px;
}
.shopIndexPage .sort .sort-total .num {
  color: #ea8e00;
  line-height: 14px;
}
.shopIndexPage .sort .sort-total .desc {
  line-height: 14px;
  color: Black;
}
.shopIndexPage .isStock i.fa {
  display: none;
  font-size: 13px;
}
.shopIndexPage .isStock.select i.fa {
  display: inline-block;
}
.shopIndexPage .isNew i.fa {
  display: none;
  font-size: 13px;
}
.shopIndexPage .isNew.select i.fa {
  display: inline-block;
}

.shopIndexPage .shoppro-list {
  background: #eeedee;
  overflow: hidden;
  padding-top: 2%;
  margin-top: 2%;
}
.shopIndexPage .shoppro-list .item {
  width: 49%;
  float: left;
  margin-bottom: 10px;
  background: white;
}
.shopIndexPage .shoppro-list .item.rigthmargin {
  margin-right: 2%;
}
.shopIndexPage .shoppro-list .item .top {
  position: relative;
}
.shopIndexPage .shoppro-list .item .top img {
  width: 100%;
  height: 185px;
  display: block;
}
.shopIndexPage .shoppro-list .text {
  padding: 0 5px;
}
.shopIndexPage .shoppro-list .text .money {
  font-size: 12px;
  overflow: hidden;
  margin: 5px 0;
}
.shopIndexPage .shoppro-list .text .money .price {
  float: left;
  color: Red;
  padding-left: 5px;
  line-height: 1rem;
}
.shopIndexPage .shoppro-list .text .money .price span {
  font-size: 16px;
  font-weight: 700;
}
.shopIndexPage .shoppro-list .text .money .del-price {
  float: left;
  color: #a0a0a0;
  text-decoration: line-through;
  margin-left: 10px;
  line-height: 18px;
}
.shopIndexPage .shoppro-list .item .name {
  width: 100%;
  overflow: hidden;
  height: 36px;
  line-height: 18px;
  font-size: 12px;
  margin-bottom: 7px;
}
.shopIndexPage .mu-tabs {
  background-color: #f5f5f5;
  color: #000;
}
.shopIndexPage .mu-tab-link {
  color: rgb(0, 0, 0);
}
.shopIndexPage .mu-tab-active {
  color: orange;
  background: #ffefd2;
}


.shopIndexPage-shareSheetTitle {
  line-height: 40px;
  font-size: 16px;
  padding: 20px 20px 0;
}
.shopIndexPage-shareSheetWayList {
  overflow: hidden;
}
.shopIndexPage-shareSheetWayList .shareSheetWayItem {
  float: left;
  padding: 20px;
  width: 100px;
  text-align: center;
}
.shopIndexPage-shareSheetWayList .shareSheetWayItem .shareWayIcon {
  font-size: 28px;
  border-radius: 50%;
  width:45px;
  height:45px;
  line-height: 45px;
  text-align: center;
  color:white;
  display: inline-block;
}
.shopIndexPage-shareSheetWayList .shareSheetWayItem .shareWayIcon.wechatFrind{
  background: #07BD13;
}
.shopIndexPage-shareSheetWayList .shareSheetWayItem .shareWayIcon.wechatFrindQuan{
  background: #99D021;
}
.shopIndexPage-shareSheetWayList .shareSheetWayItem .shareWayText {
  padding-top: 10px;
}
</style>
    


// WEBPACK FOOTER //
// src/pages/shop/shouye.vue